module.exports = __webpack_public_path__ + "img/canal.d9ed7df8.png";